import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import axios from 'axios';
import { environment } from '../../../environments/environment';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-incidents',
  templateUrl: './incidents.component.html',
  styleUrls: ['./incidents.component.scss']
})
export class IncidentsComponent implements OnInit {
  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  loading = true;
  isAdmin = false;
  incidents = [];
  selectedBase = {
    baseCode: '',
    value: ''
  };
  bases;
  states;
  modal = {
    active: false,
    data: {}
  };
  selectedYear = {
    name: 2004,
    value: 2004
  };
  years = [];

  headings = [
    {
      label: 'Date',
      key: '_incidentDate',
      type: 'date'
      // friendly: 'friendlyDate'
    },
    {
      label: 'Incident Name',
      key: '_nameofIncident'
    },
    {
      label: 'State',
      key: 'state'
    },
    {
      label: 'Mode',
      key: '_mode'
    },
    {
      label: 'Mission',
      key: '_mission'
    }
  ];
  settings = {
    name: 'Incident',
    route: 'incidents',
    menuItems: [
      {
        label: 'New Incident',
        action: 'new',
        route: 'incidents/new'
      },
      {
        label: 'Edit Incident',
        action: 'edit',
        route: 'incidents/'
      },
      {
        label: 'Delete Incident',
        action: 'delete',
        route: 'incidents/'
      }
    ]
  };
  archived = false;

  constructor(
    private route: ActivatedRoute,
    private toast: ToastService,
    private router: Router
  ) {}

  ngOnInit() {
    let base = window.sessionStorage.getItem('incidentsBase');
    this.selectedBase.baseCode = base;
    this.selectedBase.value = base;
    if (
      this.userInfo.role === 'admin' ||
      this.userInfo.role === 'baseadmin' ||
      this.userInfo.role === 'sysadmin'
    ) {
      this.isAdmin = true;
    }

    // populate years dropdown
    for (let year = new Date().getFullYear(); year > 2003; year--) {
      this.years.push({ name: year, value: year });
    }

    // select year from session storage to return user to previous view
    let incidentsYear = Number(window.sessionStorage.getItem('incidentsYear'));
    this.selectedYear = {
      name: incidentsYear,
      value: incidentsYear
    };

    this.getBasesAndStates();
  }

  getBasesAndStates = async () => {
    let states = await axios.get(environment.API_URL + '/states', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.states = states.data;
    let bases = await axios.get(environment.API_URL + '/base/dropdown/main', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    this.bases = bases.data;
    this.bases.forEach((base) => {
      base.displayValue = base.text + ' (' + base.baseCode + ')';
    });
    // here we set the initial selected base to the users home base
    this.bases.forEach((base) => {
      if (base.baseCode === this.selectedBase.baseCode) {
        this.selectedBase = base;
      }
    });
    this.refreshIncidents();
  };

  confirmDeleteIncident = (incident) => {
    this.modal = {
      data: {
        content: 'Are you sure you want to delete this incident?',
        deny: 'Cancel',
        confirm: 'Delete',
        action: 'delete',
        incident: incident
      },
      active: true
    };
    // focus on the first modal button for accessability
    setTimeout(() => {
      document.getElementById('btn1').focus();
    }, 100);
  };
  
  deleteIncident = async (incident) => {
    let userId = this.userInfo.id;
    let id = '';
    if (incident.id) {
      id = incident.id;
    } else if (incident.href) {
      id = incident.href.slice(
        incident.href.indexOf('/incidents/') + '/incidents/'.length,
        incident.href.length
      );
    }
    axios
      .delete(
        environment.API_URL + '/incidents/' + id + '/delete?userId=' + userId,
        {
          headers: { Authorization: 'Bearer ' + this.token }
        }
      )
      .then((response) => {
        this.toast.show('Deleted Incident', 'success');
        this.refreshIncidents();
      })
      .catch((error) => {
        this.toast.show('Error deleting Incident', 'error');
      });
  };

  refreshIncidents = async () => {
    this.loading = true;
    let incidents;
    let baseCode = this.selectedBase.baseCode;
    let url =
      environment.API_URL +
      '/incidents/?baseCode=' +
      baseCode +
      '&limit=999999&offset=0&year=' +
      this.selectedYear.value;

    try {
      incidents = await axios.get(url, {
        headers: { Authorization: 'Bearer ' + this.token }
      });
      this.loading = false;
      // here we format the date for the table
      if (incidents.data.value.length > 0) {
        incidents.data.value.forEach((incident) => {
          let date = incident._incidentDate
          let formattedDate = new Date(date).toLocaleDateString();
          incident._incidentDate = formattedDate; 
        });
      };
    } catch (error) {
      console.dir(error);
      this.loading = false;
      this.toast.show('Unable to retreive incidents.', 'error');
    }

    this.incidents = incidents.data.value;

    this.incidents.forEach(async (incident) => {
    // get incident state
      this.states.filter((state) => {
        if (state.id === incident._stateId) {
          incident.state = state.text;
        }
      });
    });

    // default sort by descending by date
    this.incidents.sort((a, b) => {
      var keyA = a._incidentDate;
      var keyB = b._incidentDate;
      if (keyA < keyB) {
        return 1;
      }
      if (keyA > keyB) {
        return -1;
      }
      return 0;
    });
  };

  modalConfirmed = (data) => {
    if (data.action === 'delete') {
      this.deleteIncident(data.incident);
    }
    this.modal.active = false;
  };
  modalDenied = (data) => {
    this.modal.active = false;
  };

  selectBase = (base) => {
    window.sessionStorage.setItem('incidentsBase', base.baseCode);
    this.selectedBase = base;
    this.refreshIncidents();
  };

  selectYear = (year) => {
    window.sessionStorage.setItem('incidentsYear', year.value.toString());
    this.selectedYear = year;
    if (year.value === 'current') {
      this.archived = false;
    } else {
      this.archived = true;
    }
    this.refreshIncidents();
  };
}
